import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

/**
 * 振替登録画面
 *
 * @export
 * @class Sgke040dComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'app-sgke040d',
  templateUrl: './sgke040d.component.html',
  styleUrl: './sgke040d.component.scss'
})
export class Sgke040dComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();


  // 振替登録ラジオボタン
  registType: string = '2';

  /** 未精算金管理番号 */
  @Input() kinkoMno: string = '200000000000001';
  /** 未精算金履歴番号 */
  @Input() kinkoRrkno: string = '3001';
  /** 未精算金_更新通番号 */
  @Input() kinkoUpdateSrno: string = '40001';
  /** 未精算金EX_更新通番号 */
  @Input() kinkoexUpdatesequencenumber: string = '50001';

  /**
   * コンストラクタ
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke040dComponent
   */
  constructor(
    public responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke040dComponent
   */
  ngOnInit(): void {
  }

  /**
   * 購読解除
   * @memberof Sgke040dComponent
   */
  ngOnDestroy() {
  }

  /**
   * ラジオボタン押下時
   * @param {*} event
   * @memberof Sgke040dComponent
 */
  onChangeRadio(event: string): void {
    this.registType = event;
  }

  /**
   * 020d再描画再現
   * @memberof Sgke040dComponent
   */
  search() {
    this.registType = "";
  }

  /**
* 正常メッセージ出力
*
* @private

* @param {string} message
*  @memberof Sgke040dComponent
*/
  public showNormalMsg(message: string): void {

    this.errorMessageModelArray = new Array<SgAriaMessage>;
    // メッセージオブジェクトを作成
    let messageItem: SgAriaMessage = {
      message: message,
      messageClass: "mat-card-background-primary",
      icon: "done",
      iconClass: "mat-icon-color-primary"
    };

    // errorMessageModelArrayにメッセージオブジェクトを追加
    this.errorMessageModelArray.push(messageItem);
  }

  /**
   * エラーメッセージ出力
   *
   * @private

   * @param {string} message
   * @memberof Sgke040dComponent
   */
  public showErrorMsg(message: string): void {

    this.errorMessageModelArray = new Array<SgAriaMessage>;
    // メッセージオブジェクトを作成
    let messageItem: SgAriaMessage = {
      message: message,
      messageClass: "mat-card-background-error",
      icon: "cancel",
      iconClass: "mat-icon-color-error"
    };

    // errorMessageModelArrayにメッセージオブジェクトを追加
    this.errorMessageModelArray.push(messageItem);
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke040dComponent
   */
  public clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
 * エラーメッセージ表示
 * @memberof Sgke040dComponent
 */
  showMsg(errors) {
    // メッセージを表示
    this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(errors, this.errorMessageModelArray);
  }
}
